{
    "component-card-search-list.empty-state.title.non-final": "<strong>Привязать этот репозиторий к программному компоненту</strong>",
    "component-card.add-chat-channel": "Добавить канал чата",
    "component-card.chat-channels": "Каналы чата",
    "component-card.expander.show-more-link": "Показать еще {formattedCount}"
}
